import styled from "styled-components";
import { H1 } from "components/atoms/text";
import Form from "components/templates/signUp/Form";

// 회원가입 페이지
const SignUp = () => {
  return (
    <Container>
      <H1 className="mb-15 text-primary-active md:mb-10">회원가입</H1>
      <Form />
    </Container>
  );
};

const Container = styled.div`
  max-width: 912px;
  margin: 0 auto;
  padding: 60px 16px 100px;

  @media (max-width: 767px) {
    padding: 40px 16px 80px;
  }
`;

export default SignUp;
